import * as React from 'react'
import { MatchPairProps } from '../typings'
import { ArrowIcon } from './ArrowIcon'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { SmallLocationCard } from '@user/components/Location'

import Box from '@mui/material/Box'

type LeftCardProps = MatchPairProps & {
  matched: boolean
}

export const LeftCard: React.FC<LeftCardProps> = (props) => {
  const { matched, styles, serviceLocations } = props

  const [expanded, toggleExpanded] = useToggleBoolean()

  return (
    <Box display="flex" alignItems="center">
      <SmallLocationCard
        {...props}
        open={expanded}
        toggleOpen={toggleExpanded}
        isEditable
        lastServiceLocation={serviceLocations.length === 1}
      />
      <ArrowIcon matched={matched} style={styles.arrowIcon} />
    </Box>
  )
}
LeftCard.displayName = 'LeftCard'
